import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {MobileNavigationService} from '@application/services/navigation/mobile-navigation.service';
import {NavigationService} from '@application/services/navigation/navigation.service';
import {MsalGuard} from '@azure/msal-angular';
import {AUTHENTICATION} from '@infrastructure/http/authentication/authentication';
import {RESPONSIVENESS_VIEW_MODE} from '@vdw/angular-component-library';
import {firstValueFrom} from 'rxjs';

export const canAccessRouteWithoutAuthenticationGuard = async (activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Promise<boolean> => {
  const router = inject(Router);
  const authentication = inject(AUTHENTICATION);
  const navigationService = inject(NavigationService);
  const responsivenessViewMode = inject(RESPONSIVENESS_VIEW_MODE);
  const mobileNavigationService = inject(MobileNavigationService);
  const msalGuard = inject(MsalGuard);

  let subscription = authentication.getCurrentSubscription();

  let result = subscription && (await firstValueFrom(msalGuard.canActivate(activatedRouteSnapshot, routerStateSnapshot)));

  if (result && router.url === '/') {
    const path = responsivenessViewMode.isPhone ? mobileNavigationService.getDefaultMobileRoute(subscription) : navigationService.getDefaultRoute(subscription);

    router.navigateByUrl(path);
  }

  return !result;
};
